import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

/**
 * Keeps content-authoring and diagnostic tools available in local/UAT only.
 * Production also enforces this boundary server-side by excluding the matching
 * admin mutation controllers from the `prod` Spring profile.
 */
export const nonProdOnlyGuard: CanActivateFn = () => {
  if (!environment.production) {
    return true;
  }

  return inject(Router).createUrlTree(['/home/category']);
};
